import { SectionsMonitoringTable } from "components/monitoring/SectionsMonitoringTable";

export default function Page() {
  return <SectionsMonitoringTable />;
}
